import React from 'react';
import { Loader2, X } from 'lucide-react';

function BulkAssociationModal({
  isOpen,
  selectedRiskCount,
  saving,
  processSelectionCount,
  onClose,
  onSave,
  children,
}) {
  if (!isOpen) return null;

  const disableSave = saving || selectedRiskCount === 0 || processSelectionCount === 0;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <button
        type="button"
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
        aria-label="Close bulk association popup"
      />
      <div className="relative z-10 w-full max-w-2xl rounded-xl border border-gray-200 bg-white p-5 shadow-xl">
        <div className="mb-4 flex items-start justify-between gap-3">
          <div>
            <h3 className="text-base font-semibold text-gray-900">Map processes</h3>
            <p className="mt-1 text-sm text-gray-600">
              Apply to <span className="font-semibold">{selectedRiskCount}</span>{' '}
              {selectedRiskCount === 1 ? 'selected risk' : 'selected risks'}.
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            disabled={saving}
            className="rounded-md p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-700 disabled:opacity-50"
            aria-label="Close"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="min-h-[15rem]">{children}</div>

        <div className="mt-5 flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            disabled={saving}
            className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onSave}
            disabled={disableSave}
            className="inline-flex items-center gap-2 rounded-md border border-blue-600 bg-blue-600 px-3 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50"
          >
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default BulkAssociationModal;
